var LayoutPerspective = require('./../layout/LayoutPerspective');
var editStoredPaymentMethodTemplate = require('./editStoredPaymentMethodTemplate.hbs');
var PatientStoredPaymentMethodView = require('./PatientStoredPaymentMethodView');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');

/**
 * Perspective to display new/edit stored payment method page
 *
 * @class StoredPaymentMethodEditPerspective
 * @constructor
 * @param options {Object} Options to configure this perspective.
 *   @param [options.patientVecnaId] {String} the vecna id of the current patient
 */
module.exports = LayoutPerspective.extend({
  template: editStoredPaymentMethodTemplate,
  moduleNamespace: 'editStoredPaymentMethod',

  behaviors: {
    portalPerspectiveLayoutBehavior: {
      behavior: PortalPerspectiveLayoutBehavior
    }
  },

  injectionSites: {
    'stored-payment-method': '_patientNewStoredMethodView'
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this perspective.
   *   @param options.patientVecnaId {String} the vecna id of the current patient
   *   @param options.storedPaymentMethodId] {String} the id of the stored payment method.
   */
  initialize: function(options) {
    LayoutPerspective.prototype.initialize.apply(this);
    options = options || {};
    this._patientNewStoredMethodView = new PatientStoredPaymentMethodView({
      patientVecnaId: options.patientVecnaId,
      storedPaymentMethodId: options.storedPaymentMethodId
    });
  }
});
